import tokens from '@ifood/pomodoro-tokens';
import styled, { css } from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

import Link from '../Link';

export const Container = styled.div<LayoutProps & SpaceProps>`
  margin-bottom: 0px;
  padding-top: 0px;
  line-height: 1;

  ${space}
  ${layout}
`;

type ContentProps = {
  leftSpace?: boolean;
};

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ leftSpace }): string => (leftSpace ? tokens.space.large : '0')};
`;

export const LinksStyles = css`
  font-family: ${tokens.fonts.primary};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.black};
  display: block;
  margin-bottom: ${tokens.space.smaller};

  &:focus {
    color: ${tokens.colors.black};
  }

  &.active {
    color: ${tokens.colors.primary};
  }
`;

export const LinkSidebarItem = styled(Link)`
  ${LinksStyles};
`;

export const Span = styled.span`
  ${LinksStyles};

  cursor: pointer;
`;
